import CenterForm from "./CenterForm";
import { CommonTexts } from "locale/es";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DrawerHeader from "components/DrawerHeader";
import BreadCrumbs from "components/Breadcrumbs/Breadcrumbs";
import { AppColors } from "resources/AppColors";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import { updateCenterAction } from "redux/reducers/centersReducer";

export function DisplayEditCenterForm() {
  const { entity } = useLocation().state;

  const navigate = useNavigate()

  function handleNavigateBack() {
    navigate("/gestio-dels-centres");
  }

  return (
    <Box pt={4} pb={12} px={3} width="100%">
      <DrawerHeader />
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <IconButton
          sx={{ color: AppColors.PRIMARY, mt: -2 }}
          onClick={handleNavigateBack}
        >
          <ArrowBackIcon />
        </IconButton>
        <BreadCrumbs
          name={`${CommonTexts.CENTERS} / ${entity?.name}`}
          icon={<AddBusinessIcon sx={{ mr: 0.5 }} fontSize='inherit' />}
          mb={2}
        />
      </Box>
      <Box sx={{
        mx: "auto"
      }}
      >
        <CenterForm
          selectedCenter={entity}
          onSubmit={updateCenterAction}
        />
      </Box>
    </Box>

  )
}